import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useApp } from '../../context/AppContext';
import SupportTicketList from '../../components/support/tickets/SupportTicketList';
import { getTicketViewConfig } from '../../config/ticketViewConfig';
import styled from 'styled-components';

const PageContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 2rem;
  background-color: var(--color-bg-secondary);
  min-height: 100vh;
  overflow-x: hidden;
  width: 100%;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 1rem;
  }
`;

const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  overflow-x: hidden;
  width: 100%;
`;

const ListSection = styled.section`
  background: var(--color-bg-primary);
  border-radius: 16px;
  width: 100%;
  overflow: visible;
  border: 1px solid var(--color-border-primary);
  box-shadow: var(--shadow-sm);
  padding: 1.5rem;
  box-sizing: border-box;

  @media (max-width: 768px) {
    padding: 1rem;
    border-radius: 12px;
  }
`;

/** Tempo sem requisição em andamento para considerar a primeira carga concluída. */
const SETTLE_DELAY_MS = 250;

const TicketsListPage = () => {
  const location = useLocation();
  const { applyViewConfig, loading, kanbanLoading } = useApp();
  const config = getTicketViewConfig(location.pathname);
  const [configReady, setConfigReady] = useState(false);
  const [initialLoadDone, setInitialLoadDone] = useState(false);
  const isFetching = loading || kanbanLoading;

  useEffect(() => {
    let active = true;
    setConfigReady(false);
    setInitialLoadDone(false);

    Promise.resolve(
      applyViewConfig({
        viewKey: config.viewKey,
        demandTypePreset: config.demandTypePreset,
        defaultStatus: config.defaultStatus,
      })
    )
      .catch((err) => {
        console.error('Erro ao aplicar a configuração da lista de tickets:', err);
      })
      .finally(() => {
        if (active) setConfigReady(true);
      });

    return () => {
      active = false;
    };
  }, [location.pathname, config.viewKey, config.demandTypePreset, config.defaultStatus, applyViewConfig]);

  useEffect(() => {
    if (!configReady || isFetching || initialLoadDone) return undefined;
    const timer = window.setTimeout(() => setInitialLoadDone(true), SETTLE_DELAY_MS);
    return () => window.clearTimeout(timer);
  }, [configReady, isFetching, initialLoadDone]);

  return (
    <PageContainer>
      <ContentContainer>
        <ListSection>
          <SupportTicketList
            listTitle={config.title}
            lockDemandType={config.demandTypePreset.length > 0}
            viewKey={config.viewKey}
            initialLoading={!initialLoadDone}
            demandTypeFilter={
              config.demandTypePreset.length === 1 ? config.demandTypePreset[0] : null
            }
          />
        </ListSection>
      </ContentContainer>
    </PageContainer>
  );
};

export default TicketsListPage;
